import React, { useState } from 'react';
import { Bell, User, LogOut } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useNotifications } from '../contexts/NotificationContext';
import { useNavigate } from 'react-router-dom';
export function Header() {
  const {
    user,
    logout
  } = useAuth();
  const {
    notifications,
    unreadCount
  } = useNotifications();
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  return <header className="sticky top-0 z-40 bg-white border-b border-gray-200" data-id="element-236">
      <div className="px-4 lg:px-8 h-16 flex items-center justify-between" data-id="element-237">
        {/* Left side - Logo */}
        <div className="flex items-center gap-3" data-id="element-238">
          <img src="https://i.imgur.com/bxPZvDb.png" alt="Cricket Logo" className="h-10 w-auto object-contain" data-id="element-239" />
        </div>

        {/* Right side - Actions */}
        <div className="flex items-center gap-2" data-id="element-240">
          {/* Notifications */}
          <div className="relative" data-id="element-241">
            <button onClick={() => setShowNotifications(!showNotifications)} className="relative p-2.5 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors" aria-label="Notifications" data-id="element-242">
              <Bell size={20} data-id="element-243" />
              {unreadCount > 0 && <span className="absolute top-1 right-1 w-5 h-5 bg-orange-500 text-white text-xs font-bold rounded-full flex items-center justify-center" data-id="element-244">
                  {unreadCount}
                </span>}
            </button>

            {showNotifications && <div className="absolute right-0 mt-2 w-80 bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden" data-id="element-245">
                <div className="p-4 border-b border-gray-200" data-id="element-246">
                  <h3 className="font-semibold text-gray-900" data-id="element-247">
                    Notificaciones
                  </h3>
                  {unreadCount > 0 && <p className="text-xs text-gray-500 mt-0.5" data-id="element-248">
                      {unreadCount} sin leer
                    </p>}
                </div>
                <div className="max-h-96 overflow-y-auto" data-id="element-249">
                  {notifications.length === 0 ? <div className="p-8 text-center text-gray-500" data-id="element-250">
                      <Bell size={32} className="mx-auto mb-2 opacity-30" data-id="element-251" />
                      <p className="text-sm" data-id="element-252">No hay notificaciones</p>
                    </div> : notifications.slice(0, 5).map(notification => <div key={notification.id} className={`p-4 border-b border-gray-100 hover:bg-gray-50 transition-colors cursor-pointer ${!notification.read ? 'bg-orange-50' : ''}`} data-id="element-253">
                        <p className="font-medium text-sm text-gray-900" data-id="element-254">
                          {notification.title}
                        </p>
                        <p className="text-xs text-gray-600 mt-1" data-id="element-255">
                          {notification.message}
                        </p>
                        <p className="text-xs text-gray-400 mt-1" data-id="element-256">
                          {notification.timestamp}
                        </p>
                      </div>)}
                </div>
              </div>}
          </div>

          {/* User Menu */}
          <div className="relative" data-id="element-257">
            <button onClick={() => setShowUserMenu(!showUserMenu)} className="flex items-center gap-2 px-3 py-2 rounded-xl hover:bg-gray-100 transition-colors" data-id="element-258">
              <div className="w-8 h-8 rounded-lg bg-black flex items-center justify-center" data-id="element-259">
                <User size={16} className="text-white" data-id="element-260" />
              </div>
              <div className="hidden sm:block text-left" data-id="element-261">
                <p className="text-sm font-medium text-gray-900" data-id="element-262">
                  {user?.name}
                </p>
                <p className="text-xs text-gray-500 -mt-0.5" data-id="element-263">
                  {user?.role === 'admin' ? 'Administrador' : 'Empleado'}
                </p>
              </div>
            </button>

            {showUserMenu && <div className="absolute right-0 mt-2 w-56 bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden" data-id="element-264">
                <div className="p-3 border-b border-gray-200" data-id="element-265">
                  <p className="font-semibold text-gray-900" data-id="element-266">{user?.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-267">{user?.email}</p>
                </div>
                <button onClick={handleLogout} className="w-full px-4 py-3 text-left text-sm text-gray-700 hover:bg-gray-50 transition-colors flex items-center gap-2" data-id="element-268">
                  <LogOut size={16} data-id="element-269" />
                  Cerrar Sesión
                </button>
              </div>}
          </div>
        </div>
      </div>
    </header>;
}